import React, {useEffect, useRef, useState} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'

type Props = {
  onSearch: (term: string) => void
}

export function AIInterpretationSearchBar({onSearch}: Props) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [searchTerm, setSearchTerm] = useState('')

  const handleSearch = () => {
    onSearch(inputRef.current?.value?.trim() ?? '')
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  useEffect(() => {
    if (searchTerm === '') {
      onSearch('')
    }
  }, [searchTerm, onSearch])

  return (
    <div className='d-flex align-items-center position-relative'>
      <input
        ref={inputRef}
        type='text'
        className='form-control form-control-white form-control-sm w-250px custom-search-radius'
        placeholder='Search Requester (name, email, IVR PIN)'
        onKeyDown={handleKeyDown}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <button
        type='button'
        className='btn btn-primary btn-sm custom-search-btn-radius px-4 btn-icon'
        onClick={handleSearch}
      >
        <KTSVG path='/media/icons/duotune/general/gen021.svg' className='' />
      </button>
    </div>
  )
}
